import React, { Fragment, useEffect, useState } from 'react';
import Swal from 'sweetalert2';

import "./Solicitud.css"

import icon1 from "../../../Images/Icon/64.png"

import inscripcionesDataHelper from '../../../Helpers/InscripcionData';


const Solicitud = () => {
    const periodo = [
        "",
        "Enero - Abril",
        "Mayo - Agosto",
        "Septiembre - Diciembre",
    ]
    const [archivado, setArchivado] = useState(false);
    const [solicitud, setSolicitud] = useState({
        nombre:"Cargando ...",
        domicilio:"Cargando ...",
        colonia:"Cargando ...",
        ciudad:"tlajomulco",
        nombrePadre:"Cargando ...",
        telefonoEmergencia:"Cargando ...",
        domicilioEmpresa:"Cargando ...",
        fecha:"Cargando ...",
        licenciatura:"Cargando ...",
        celular:"Cargando ...",
        email:"Cargando ...",
        nombreMadre:"Cargando ...",
        nombreEmpresa:"Cargando ...",
        formatoPago:"Cargando ...",
        pdfs:[],
        status:1
    });

    useEffect(() => {
        let id = window.location.pathname.split("/")[2];
        if (window.location.pathname.includes("solicitud-inscripcion-archivado")) {
            setArchivado(true);
        }
        obtenerData(id);
    },[]);

    const obtenerData = async (id) => {
        let res = await inscripcionesDataHelper.obtenerUnData(id);
        if (res.success) {
            setSolicitud(res.data);
        } else {
            Swal.fire(
                'Error!',
                'No se pudo obtner los datos, codigo: ' + res.code ,
                'error'
            )
        }
    }

    const nuevoStatus = estatus => {
        let copiaData = {...solicitud};
        copiaData.estadoAlumno = !estatus;
        inscripcionesDataHelper.editarData(copiaData, copiaData._id);
    }

    const archivar = () => {
        let copiaData = {...solicitud};
        copiaData.archivado = true;
        inscripcionesDataHelper.editarData(copiaData, copiaData._id);
    }

    const descargarPdf = (pdf, index) => {
        // const container = document.querySelector('#container');
        const tempLink = document.createElement('a');
        tempLink.href = pdf;
        // tempLink.href = `data:application/pdf;base64,${base64String}`;
        tempLink.setAttribute('download', `${solicitud.nombre}-${index}.pdf`);
        //container.append(tempLink);
        tempLink.click();
    }

    return(
        <Fragment>
            <div style={{marginBottom:"100px"}}>
                <p className='titulo_solicitud' style={{textAlign:"center"}}>
                    Solicitud de inscripción
                </p>
                <div className='box_solicitud_1'>
                    <div className='row'>
                        <div className='col s4'>
                            <div className='cont_1'>
                                <p className='texto_solicitud_3'>Licenciatura</p>
                                <p className='texto_solicitud_4'>{solicitud.licenciatura.toUpperCase()} </p>
                            </div>
                            <div className='cont_1'>
                                <p className='texto_solicitud_3'>Periodo Escolar</p>
                                <p className='texto_solicitud_4'>{periodo[solicitud.periodo]} </p>
                            </div>
                            <div className='cont_1'>
                                <p className='texto_solicitud_3'>Nombre</p>
                                <p className='texto_solicitud_4'>{solicitud.nombre} </p>
                            </div>
                            <div className='cont_1'>
                                <p className='texto_solicitud_3'>Fecha Nacimiento</p>
                                <p className='texto_solicitud_4'>{solicitud.fechaNacimiento} </p>
                            </div>
                            <div className='cont_1'>
                                <p className='texto_solicitud_3'>Edad</p>
                                <p className='texto_solicitud_4'>{solicitud.edad} </p>
                            </div>
                            <div className='cont_1'>
                                <p className='texto_solicitud_3'>Domicilio</p>
                                <p className='texto_solicitud_4'>{solicitud.domicilio} </p>
                            </div>
                            <div className='cont_1'>
                                <p className='texto_solicitud_3'>Colonia</p>
                                <p className='texto_solicitud_4'>{solicitud.colonia} </p>
                            </div>
                            <div className='cont_1'>
                                <p className='texto_solicitud_3'>Código Postal</p>
                                <p className='texto_solicitud_4'>{solicitud.codigoPostal} </p>
                            </div>
                            <div className='cont_1'>
                                <p className='texto_solicitud_3'>Ciudad</p>
                                <p className='texto_solicitud_4'>{solicitud.ciudad} </p>
                            </div>
                            <div className='cont_1'>
                                <p className='texto_solicitud_3'>Estado</p>
                                <p className='texto_solicitud_4'>{solicitud.estado} </p>
                            </div>
                            <div className='cont_1'>
                                <p className='texto_solicitud_3'>País</p>
                                <p className='texto_solicitud_4'>{solicitud.pais} </p>
                            </div>
                            {/* ------------ */}
                            <div className='cont_1'>
                                <p className='texto_solicitud_3'>Grupo sanguíneo</p>
                                <p className='texto_solicitud_4'>{solicitud.tipoSangre} </p>
                            </div>
                            <div className='cont_1'>
                                <p className='texto_solicitud_3'>¿Tiene alguna condicion especial?</p>
                                <p className='texto_solicitud_4'>
                                    {solicitud.condicionEspecial !== "" ? (
                                        "Si"
                                    ) : (
                                        "No"
                                    )}
                                </p>
                                {solicitud.condicionEspecial !== "" && (
                                    <Fragment>
                                        <p className='texto_solicitud_3'> Condicion:</p>
                                        <p className='texto_solicitud_4'>{solicitud.condicionEspecial}</p>
                                    </Fragment>
                                )}
                            </div>
                            <div className='cont_1'>
                                <p className='texto_solicitud_3'>¿Tiene alguna enfermedad cronica?</p>
                                <p className='texto_solicitud_4'>
                                    {solicitud.enfermedad ? (
                                        "Si"
                                    ) : (
                                        "No"
                                    )}
                                </p>
                                {solicitud.enfermedad && (
                                    <Fragment>
                                        <p className='texto_solicitud_3'> Condicion:</p>
                                        <p className='texto_solicitud_4'>{solicitud.enfermedadEspecial}</p>
                                    </Fragment>
                                )}
                            </div>
                            {/* ------------ */}

                        </div>
                        <div className='col s4'>
                            <div className='cont_1'>
                                <p className='texto_solicitud_3'>Fecha de solicitud</p>
                                <p className='texto_solicitud_4'>{solicitud.fecha} </p>
                            </div>
                            <div className='cont_1'>
                                <p className='texto_solicitud_3'>Celular</p>
                                <p className='texto_solicitud_4'>{solicitud.celular} </p>
                            </div>
                            <div className='cont_1'>
                                <p className='texto_solicitud_3'>E-mail</p>
                                <p className='texto_solicitud_4'>{solicitud.email} </p>
                            </div>
                            {/* ------------ */}
                            <div className='cont_1'>
                                <p className='texto_solicitud_3'>Escuela</p>
                                <p className='texto_solicitud_4'>{solicitud.bachiller} </p>
                            </div>
                            <div className='cont_1'>
                                <p className='texto_solicitud_3'>Generacion</p>
                                <p className='texto_solicitud_4'>{solicitud.generacion} </p>
                            </div>
                            <div className='cont_1'>
                                <p className='texto_solicitud_3'>Ciudad de la escuela</p>
                                <p className='texto_solicitud_4'>{solicitud.ciudadBachiller} </p>
                            </div>
                            {/* ------------ */}
                            <div className='cont_1'>
                                <p className='texto_solicitud_3'>Nombre del contacto de Emergencia</p>
                                <p className='texto_solicitud_4'>{solicitud.nombreEmergencia} </p>
                            </div>
                            <div className='cont_1'>
                                <p className='texto_solicitud_3'>Telefono de Emergencia</p>
                                <p className='texto_solicitud_4'>{solicitud.telefonoEmergencia} </p>
                            </div>
                            <div className='cont_1'>
                                <p className='texto_solicitud_3'>Nombre de la Madre</p>
                                <p className='texto_solicitud_4'>{solicitud.nombreMadre} </p>
                            </div>
                            <div className='cont_1'>
                                <p className='texto_solicitud_3'>Telefono de la Madre</p>
                                <p className='texto_solicitud_4'>{solicitud.telefonoMadre} </p>
                            </div>
                            <div className='cont_1'>
                                <p className='texto_solicitud_3'>Nombre del Padre</p>
                                <p className='texto_solicitud_4'>{solicitud.nombrePadre} </p>
                            </div>
                            <div className='cont_1'>
                                <p className='texto_solicitud_3'>Telefono del Padre</p>
                                <p className='texto_solicitud_4'>{solicitud.telefonoPadre} </p>
                            </div>
                            <div className='cont_1'>
                                <p className='texto_solicitud_3'>¿Como se liquida el cuatrimestre?</p>
                                <p className='texto_solicitud_4'>{solicitud.pago} </p>
                            </div>
                        </div>
                        <div className='col s4'>
                            <div className='cont_1'>
                                <p className='texto_solicitud_3 center' >Estado</p>
                                <div style={{display:"flex", justifyContent:"center", alignItems:"center" }}>
                                    {!archivado ? (
                                        solicitud.estadoAlumno === false ? (
                                            <button onClick={() => {nuevoStatus(solicitud.estadoAlumno)}} className='caja_status_1'>
                                                <p>
                                                    PENDIENTE
                                                </p>
                                            </button> 
                                        ) : (
                                            <button onClick={() => {nuevoStatus(solicitud.estadoAlumno)}} className='caja_status_2' >
                                                <p>
                                                    ATENDIDO
                                                </p>
                                            </button>    
                                        )
                                    ) : (
                                        solicitud.estadoAlumno === false ? (
                                            <button className='caja_status_1'>
                                                <p>
                                                    PENDIENTE
                                                </p>
                                            </button> 
                                        ) : (
                                            <button className='caja_status_2' >
                                                <p>
                                                    ATENDIDO
                                                </p>
                                            </button>    
                                        )
                                    )}
                                </div>
                            </div>
                            <div style={{display:"flex", justifyContent:"center", flexDirection:"column", padding:"0px 15%"}}>
                                <div>
                                    <p className='texto_solicitud_3'>Archivos</p>
                                    <div style={{display:"flex", justifyContent:"space-between", gap:"10"}}>
                                        {solicitud.pdfs.map((pdf, index) => (
                                            <button onClick={() => {descargarPdf(pdf, index)}} className='btn_descarga'>
                                                Descargar
                                            </button>
                                        ))}
                                    </div>
                                </div>
                                {!archivado && (
                                    <button onClick={archivar} className='btn_archivar'>
                                        <img src={icon1} alt=""/>
                                        Archivar
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Solicitud;